import React from 'react';

// CORE COMPONENTS
import Button from 'core/tools/Button';

// STYLES
import styles from './externalLinkCell.module.scss';

export default function ExternalLinkCell({ children, icon = 'view', label, value = children, placeholder }) {
  return ![undefined, null, ''].includes(value) ? (
    <Button.Link href={value} target="_blank" icon={icon} label={label || 'View'} className={styles.link} />
  ) : (
    placeholder || null
  );
}
